export const environment = {
  production: false,
  backendUrl:'https://dev.currency.hecbill.hecticus.com'
  //backendUrl:'https://dev.currency.hecbill.hecticus.com'
  //backendUrl:'https://dev.currency.hecbill.hecticus.com'
  //backendUrl:'https://dev.currency.hecbill.hecticus.com'
};
